<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Project" :label-cols="3">
          <b-form-input
            type="text"
            v-model="form.identifier"
            placeholder="Enter Project Name"
            :state="!$v.form.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Event Code" :label-cols="3">
          <b-form-input
            type="text"
            v-model="form.event_code"
            placeholder="Enter Project Event Code (optional)"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="3" class="pt-2">Grower</b-col>
      <b-col v-if="$store.getters.getAuthCustomerID">
        <b-input-group>
          <b-form-select
            v-model="form.customer_grower_id"
            :options="customer_grower_options"
          >
            <template slot="first">
              <option :value="null">
                Select Grower
              </option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group>
          <b-form-input
            type="text"
            v-model="form.grower"
            placeholder="Enter Project Grower"
            :state="!$v.form.grower.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Storage Bin" :label-cols="3">
          <b-form-input
            type="text"
            v-model="form.storage_bin"
            placeholder="Enter Project Storage Bin"
            :state="!$v.form.storage_bin.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import CustomerGrowerCollection from '@/collections/crm/CustomerGrowerCollection'

export default {
  name: "PotatoFieldFormGroups",
  mixins: [validationMixin, ToastNotifications],
  props: ["submission", "index"],
  data() {
    return {
      form: {
        identifier: null,
        event_code: null,
        grower: null,
        storage_bin: null,

        customer_grower_id: null
      },
      customer_grower: new CustomerGrowerCollection(),
    };
  },
  validations: {
    form: {
      identifier: { required },
      grower: { required },
      storage_bin: { required }
    }
  },
  computed: {
    customer_grower_options () {
      return this.customer_grower && this.customer_grower.models && this.customer_grower.models.map((grower) => {
        return {
          value: grower.id,
          text: grower.name
        }
      }) || []
    }
  },
  watch: {
    form: {
      handler() {
        this.$emit("onFieldChange", this.form);
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.form.identifier = value.identifier;
        this.form.event_code = value.event_code;
        this.form.grower = value.submission_potato.grower;
        this.form.storage_bin = value.submission_potato.storage_bin;
      },
      deep: true,
      immediate: true
    },
    'form.customer_grower_id': {
      handler (value) {
        if (value) {
          this.form.grower = this.customer_grower.models.find((grower) => grower.id === value).name
        } else {
          this.form.grower = null
        }
      },
      immediate: true
    },
  },
  mounted () {
    this.fetchCustomerGrower()
  },
  methods: {
    fetchCustomerGrower () {
      const collection = new CustomerGrowerCollection()
      const filter = collection.getFilter()

      filter.filterEquals('customer.id', this.$store.getters.getAuthCustomerID)

      collection.fetch().then(() => {
        this.customer_grower = collection
      })
    }
  }
};
</script>
